// extracted by mini-css-extract-plugin
module.exports = {"main":"NewGamePage_main__3qCBx"};